import React, { useState, useEffect } from 'react';
import './App.css';
import WeatherCard from './components/WeatherCard';
import SearchBar from './components/SearchBar';
import Forecast from './components/Forecast';
import LoadingSpinner from './components/LoadingSpinner';
import ErrorMessage from './components/ErrorMessage';
import Introduction from './components/Introduction';
import { getCurrentWeather, getForecast } from './services/weatherService';

function App() {
  const [weather, setWeather] = useState(null);
  const [forecast, setForecast] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentCity, setCurrentCity] = useState('London');
  const [showIntroduction, setShowIntroduction] = useState(false);

  // Load initial weather data
  useEffect(() => {
    loadWeatherData(currentCity);
  }, []);

  const loadWeatherData = async (city) => {
    setLoading(true);
    setError(null);
    
    try {
      const [weatherData, forecastData] = await Promise.all([
        getCurrentWeather(city),
        getForecast(city)
      ]);
      
      setWeather(weatherData);
      setForecast(forecastData);
      setCurrentCity(city);
    } catch (err) {
      setError(err.message || 'Failed to load weather data');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (city) => {
    if (city && city.trim()) {
      loadWeatherData(city.trim());
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>🌤️ Weather App</h1>
        <p>Get real-time weather data for any city</p>
        <button 
          className="intro-button"
          onClick={() => setShowIntroduction(true)}
        >
          📖 Introduction
        </button>
      </header>

      <main className="App-main">
        <SearchBar onSearch={handleSearch} loading={loading} />
        
        {loading && <LoadingSpinner />}
        
        {error && <ErrorMessage message={error} />}
        
        {weather && !loading && (
          <WeatherCard 
            weather={weather} 
            city={currentCity}
            onRefresh={() => loadWeatherData(currentCity)}
          />
        )}
        
        {forecast && !loading && (
          <Forecast forecast={forecast} />
        )}
      </main>

      <footer className="App-footer">
        <p>Powered by OpenWeatherMap API & Cloudflare Workers</p>
        <p>Built with React & Python</p>
      </footer>

      {showIntroduction && (
        <Introduction onClose={() => setShowIntroduction(false)} />
      )}
    </div>
  );
}

export default App;
